import React from 'react'
import "../App.css"

function notgaming() {
  return (
    <div>
        <span className='status'>ゲームが開始されていません</span>
    </div>
  )
}

export default notgaming